import React, { useEffect, useMemo, useRef } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import CommonSelect from "../../../ui-compoenents/CommonSelect";
import AntdDatePickerField from "../../../ui-compoenents/AntdDatePickerField";
import AntdDateTimePickerField from "../../../ui-compoenents/AntDateTimePickerField";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import NakshtraSchema from "../schema";
import nakshraInitialValues from "../initialValues";
import {
  createNakshatrAsync,
  getNakshatrAsync,
  getNakshatrListAsync,
} from "../../../data/redux/features/nakshtra/slice";

const DATETIME_FORMAT = process.env.REACT_APP_DATETIME_FORMAT;

const AddNakshtraFormModal = ({ selectedItem }) => {
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const { loading, nakshtraListData } = useSelector((state) => state.nakshtra);

  useEffect(() => {
    const modalEl = document.getElementById("add_nakshtra_form_modal");

    const handleClose = () => {
      if (formRef.current) {
        formRef.current.resetForm();
      }
    };

    modalEl?.addEventListener("hidden.bs.modal", handleClose);
    return () => modalEl?.removeEventListener("hidden.bs.modal", handleClose);
  }, []);

  useEffect(() => {
    dispatch(getNakshatrListAsync({}));
  }, [dispatch]);

  const nakshtraOptions =
    (nakshtraListData &&
      nakshtraListData.map((item) => ({
        value: item.id,
        label: item.lagan,
      }))) ||
    [];

  const finalInitailValues = useMemo(() => {
    if (selectedItem) {
      return {
        start_time: selectedItem.start_time
          ? new Date(selectedItem.start_time)
          : null,
        end_time: selectedItem.end_time
          ? new Date(selectedItem.end_time)
          : null,
        name: selectedItem.name || null,
      };
    }
    return nakshraInitialValues;
  }, [selectedItem]);

  return (
    <div className="modal fade" id="add_nakshtra_form_modal" tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <Formik
            innerRef={formRef}
            initialValues={finalInitailValues}
            validationSchema={NakshtraSchema}
            onSubmit={async (values, actions) => {
              try {
                const payload = {
                  start_time: dayjs(values.start_time).format(DATETIME_FORMAT),
                  end_time: dayjs(values.end_time).format(DATETIME_FORMAT),
                  name: values.name,
                };

                const result = await dispatch(
                  createNakshatrAsync({ createNakshatrValues: payload })
                ).unwrap();

                if (result) {
                  dispatch(getNakshatrAsync());
                }

                document.getElementById("cancle")?.click();
                actions.resetForm();
              } catch (error) {
                console.error("❌ Failed to create Lagan:", error);
              }
            }}
            enableReinitialize
          >
            {({ values, isSubmitting }) => (
              <Form>
                <div className="modal-header border-bottom pb-4">
                  <h6 className="modal-title fw-bold">
                    {selectedItem ? "Edit" : "Add"} Nakshtra
                  </h6>

                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                  />
                </div>

                <div className="modal-body pt-0">
                  <div className="row p-2 g-3">
                    <div className="col-6">
                      <label className="form-label fw-semibold">
                        Start Time
                      </label>
                      <Field
                        name="start_time"
                        component={AntdDateTimePickerField}
                        placeholder="Select Start Date"
                      />
                      <div className="text-danger small">
                        <ErrorMessage name="start_time" />
                      </div>
                    </div>

                    <div className="col-6">
                      <label className="form-label fw-semibold">End Time</label>
                      <Field
                        name="end_time"
                        component={AntdDateTimePickerField}
                        startValue={values.start_time}
                        placeholder="Select End Date"
                      />
                      <div className="text-danger small">
                        <ErrorMessage name="end_time" />
                      </div>
                    </div>

                    <div className="col-12 d-flex flex-column">
                      <label className="form-label fw-semibold">Lagan</label>
                      <Field
                        name="name"
                        component={CommonSelect}
                        placeholder="Select Lagan"
                        options={nakshtraOptions}
                        className="custom-ant-select input-mb"
                      />
                      <div className="text-danger small">
                        <ErrorMessage name="name" />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="modal-footer border-top bg-white pt-3">
                  <button
                    type="button"
                    className="btn btn-secondary btn-sm"
                    data-bs-dismiss="modal"
                    id="cancle"
                  >
                    Cancel
                  </button>

                  <button
                    type="submit"
                    className="btn btn-primary btn-sm"
                    disabled={isSubmitting || loading}
                  >
                    {selectedItem ? "Edit" : "Add"}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default AddNakshtraFormModal;
